export default __webpack_public_path__ + "static/media/75.7b6b7f22.jpg";